import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const EmptyUSlot = ({
  uNumber,
  selectValue,
  availableDevices,
  onSelectDevice,
}) => (
  <div
    style={{
      display: 'flex',
      gap: '16px',
      marginBottom: '8px',
      borderBottom: '2px solid #000',
      paddingBottom: '8px',
    }}
  >
    <div
      style={{
        border: '2px solid #000',
        padding: '8px',
        backgroundColor: '#FFFFFF',
        fontWeight: 'bold',
        borderRadius: '4px',
        boxShadow: 'inset 0 1px 3px rgba(199, 31, 31, 0.1)',
        minWidth: '80px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {uNumber}U
    </div>
    <div style={{ flex: 1 }}>
      <div
        style={{
          border: '2px solid #000',
          padding: '12px',
          backgroundColor: '#fff',
          minHeight: '50px',
          borderRadius: '4px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Select device"
          value={selectValue}
          onChange={(value) => onSelectDevice(uNumber, value)}
          dropdownRender={(menu) => <div>{menu}</div>}
        >
          {availableDevices.map((deviceItem) => (
            <Option key={deviceItem._id} value={deviceItem._id}>
              <div style={{ padding: '4px 0' }}>
                <span style={{ fontWeight: 'bold' }}>
                  {deviceItem.equipment_name}
                </span>
                {deviceItem.number_of_u ? (
                  <span style={{ color: '#888', marginLeft: 8 }}>
                    ({deviceItem.number_of_u}U)
                  </span>
                ) : null}
              </div>
            </Option>
          ))}
        </Select>
      </div>
    </div>
  </div>
);

export default EmptyUSlot;
